module.exports = __webpack_public_path__ + "static/media/vignette_04.6d918121.png";